class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
  const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
  const fieldlen = fieldsets.length;
  let option_count = 0;
  fieldsets.forEach(function(eachfield){
    var checked_gender = eachfield.querySelector('input:checked');
    if(checked_gender){
      option_count++;
    }
  });
  this.options = fieldsets.map((fieldset) => {
    if(option_count>=fieldlen){
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    }
  });
  // Voeg option1 (Color) toe vanuit variant-data, want die staat niet meer in de DOM
  const variants = this.getVariantData();
  const colorValue = variants[0].options[0];
  if (colorValue && !this.options.includes(colorValue)) {
    this.options.unshift(colorValue);
  }
  if(option_count>=fieldlen){
    document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
    document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
  }else{
    document.querySelector('.choose-cart').classList.add('hide-selectore-button');
    document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
  }
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  // toggleAddButton(disable = true, text, modifyClass = true) {
  //   const productForm = document.getElementById(`product-form-${this.dataset.section}`);
  //   if (!productForm) return;
  //   const addButton = productForm.querySelector('[name="add"]');
  //   const addButtonText = productForm.querySelector('[name="add"] > span');
  //   if (!addButton) return;
  //   if (disable) {
  //     addButton.setAttribute('disabled', 'disabled');
  //     if (text) addButtonText.textContent = text;
  //   } else {
  //     addButton.removeAttribute('disabled');
  //     addButtonText.textContent = window.variantStrings.addToCart;
  //   }
  //   if (!modifyClass) return;
  // }
  toggleAddButton(disable = true, text, modifyClass = true){
    const productForm = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    if (!productForm) return;
    productForm.forEach((form) => {
      const addButton = form.querySelector('[name="add"]');
      const addButtonText = form.querySelector('[name="add"] > span');
      if(this.currentVariant != undefined){
        if(this.currentVariant.available){
          form.querySelector(".choose-cart").classList.remove('variant_sold-out');
          document.body.classList.remove('variant_sold-out');
        }else{
          form.querySelector(".choose-cart").classList.add('variant_sold-out');
          document.body.classList.add('variant_sold-out');
        }
      }
      if(document.querySelector('.var-parent input[data-id="'+this.currentVariant.id+'"]').getAttribute('data-val') == 'pre-order'){
        addButtonText.closest('.product-addcart').classList.add('pre-order');
        addButtonText.textContent = window.variantStrings.preOrder;
      }else{
        addButtonText.closest('.product-addcart').classList.remove('pre-order');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (!addButton) return;
      if (!modifyClass) return;
    })
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            if(button.path){
              dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
            }else{
              dropdown.querySelector('.variant-dropdown').innerHTML = button.target.value;
            }
          });
        });
      });
    });
  }
}
document.querySelector('.product-addcart').addEventListener('click',function(evt){
  evt.preventDefault();
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  var cartform = document.querySelector('.product-addcart').closest('form');
  const formData = new FormData(cartform);  
  config.body = formData;
  fetch(`${routes.cart_add_url}`, config)
  .then((response) => response.json())
  .then((response) => {
    if (response.status) {
      document.querySelector('.product-form-error').innerHTML = response.description;
      setTimeout(function(e){
        document.querySelector('.product-form-error').innerHTML  = '';
      },2000);
      return;
    }else{
      if(typeof load_cart == 'function'){
        load_cart();
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);
      }else{
        window.location.href = "/cart";
      }
    }
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {

  });
});
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function product_slider(){
  if(document.querySelector('.media-slider')){
    var swiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto'
    });
    var swiper2 = new Swiper(".media-nav", {
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      thumbs: {
        swiper: swiper,
      },
    });
  }
}
product_slider();
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});

// function getElementY(query) {
//   return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
// }
// function doScrolling(element, duration) {
// 	var startingY = window.pageYOffset
//   var elementY = getElementY(element)
//   var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
// 	var diff = targetY - startingY
//   var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
//   var start
//   if (!diff) return
// 	window.requestAnimationFrame(function step(timestamp) {
//     if (!start) start = timestamp
//     var time = timestamp - start
//     var percent = Math.min(time / duration, 1)
//     percent = easing(percent)
//     window.scrollTo(0, startingY + diff * percent)
//     if (time < duration) {
//       window.requestAnimationFrame(step)
//     }
//   })
// }
// if(document.querySelector('.choose-selector')){
//   if (window.innerWidth < 641) {
//     document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
//   }
// }

// function boxHeight(){
//   document.querySelector('.media-thumb-cursor').style.top = parseFloat(((window.pageYOffset / document.querySelector('.product-media').clientHeight) * 100).toFixed(2)) + '%'
// }
// addEventListener("DOMContentLoaded", boxHeight)
// addEventListener("resize", boxHeight)
// window.addEventListener('scroll', (e)=>{
//   let scrollDistance = window.pageYOffset
//   let mediaCount = document.querySelectorAll('.prod-thumb-wrap .media-grid-column').length
//   var mainScroll = (scrollDistance / (document.querySelector('.product-media').clientHeight - window.innerHeight)) * 100;
//   var thumbScroll = (scrollDistance / (document.querySelector('.prod-thumb-inr .prod-thumb-wrap').clientHeight - window.innerHeight)) * 100;
//   let mainCurrent = parseFloat(((scrollDistance / document.querySelector('.product-media').clientHeight) * 100).toFixed(2))
//   let thumbCurrent = parseFloat((((scrollDistance + document.querySelector('.media-thumb-cursor').clientHeight) / document.querySelector('.prod-thumb-inr .prod-thumb-wrap').clientHeight) * 100).toFixed(2))
//   if(mainScroll <= 100){
//     document.querySelector('.media-thumb-cursor').style.top = mainCurrent +'%'
//   }
// })

// document.addEventListener('DOMContentLoaded', function () {
//   const mobItems = document.querySelectorAll('.media-grid > .media-grid-column');
//   const thumbItems = document.querySelectorAll('.prod-thumb .media-grid-column');

//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         const index = Array.from(mobItems).indexOf(entry.target);
//         thumbItems.forEach(el => el.classList.remove('active'));
//         if (thumbItems[index]) {
//           thumbItems[index].classList.add('active');
//           console.log('Activated index:', index);
//         }
//       }
//     });
//   }, {
//     root: null,
//     threshold: 0.3, // try 0.1 or 0.3 to make it more sensitive
//   });

//   mobItems.forEach(el => observer.observe(el));
// });

// var parentBox = document.getElementById('mediaThumbDragParent');
// var box = document.getElementById('mediaThumbDragBox');
// var isMouseDown = false;
// var initialMouseX, initialMouseY, initialBoxX, initialBoxY;
// box.addEventListener('mousedown', handleMouseDown);
// document.addEventListener('mouseup', handleMouseUp);
// document.addEventListener('mousemove', handleMouseMove);
// function handleMouseDown(event){
//   isMouseDown = true;
//   initialMouseX = event.clientX;
//   initialMouseY = event.clientY;
//   initialBoxX = box.offsetLeft / parentBox.offsetWidth * 100;
//   initialBoxY = box.offsetTop / parentBox.offsetHeight * 100;
// }
// function handleMouseUp(){
//   isMouseDown = false;
// }
// function handleMouseMove(event){
//   if(!isMouseDown){
//     return;
//   }
//   var deltaX = (event.clientX - initialMouseX) / parentBox.offsetWidth * 100;
//   var deltaY = (event.clientY - initialMouseY) / parentBox.offsetHeight * 100;
//   var newLeft = initialBoxX + deltaX;
//   var newTop = initialBoxY + deltaY;
//   var boxWidthPct = box.offsetWidth / parentBox.offsetWidth * 100;
//   var boxHeightPct = box.offsetHeight / parentBox.offsetHeight * 100;
//   newLeft = Math.max(Math.min(newLeft, 100 - boxWidthPct), 0);
//   newTop = Math.max(Math.min(newTop, 100 - boxHeightPct), 0);
//   box.style.left = newLeft + '%';
//   box.style.top = newTop + '%';
//   const getSectionHeight = document.querySelector('.product-wrap').offsetHeight / 100;
//   document.documentElement.scrollTop = getSectionHeight * newTop;
// }
// if(document.querySelector('.prod-thumb-wrap')){
//   document.querySelector('.prod-thumb-wrap').addEventListener('dblclick',function(e){
//     document.querySelector('html').style.scrollBehavior = 'unset';
//     let top = (e.clientY - this.offsetTop)/(this.clientHeight/100);
//     top = (top - 23);
//     document.querySelector(".media-thumb-cursor").style.top = top+'%';
//     document.scrollingElement.scrollTop = (document.querySelector('.product-media').clientHeight/100)*top;
//   });
// }

// let media = document.querySelector('.product-media');
// media.addEventListener('wheel', e => {
//   const deltaY = e.deltaY;
//   const isScrollDown = deltaY > 0;
//   const maxScroll = media.scrollHeight - media.clientHeight;
//   const currentScroll = media.scrollTop;

//   const atTop = currentScroll <= 0;
//   const atBottom = currentScroll >= maxScroll - 1;

//   console.log('media',deltaY);
//   // if ((isScrollDown && atBottom) || (!isScrollDown && atTop)) {
//   //   e.preventDefault();
//   //   window.scrollBy({ top: deltaY, behavior: 'auto' });
//   // } else {
//   //   e.stopPropagation();
//   // }
// }, { passive: false });

// let panel = document.querySelector('.product-info');
// panel.addEventListener('wheel', e => {
  
//   const deltaY = e.delpageYtaY;
//   // const isScrollDown = deltaY > 0;
//   const maxScroll = panel.querySelector('.sticky-info').scrollHeight - panel.querySelector('.sticky-info').clientHeight;
//   console.log('e',e.pageY,'---',maxScroll,'---',panel.querySelector('.sticky-info').scrollHeight,'-',panel.querySelector('.sticky-info').clientHeight);
//   // const currentScroll = panel.scrollTop;

//   // const atTop = currentScroll <= 0;
//   // const atBottom = currentScroll >= maxScroll - 1;

// }, { passive: false });



// new code


// =================== Smooth Scroll ===================
function getElementY(query, scrollElement) {
  return scrollElement.scrollTop + document.querySelector(query).getBoundingClientRect().top;
}

function doScrolling(element, duration, scrollElement) {
  var startingY = scrollElement.scrollTop;
  var elementY = getElementY(element, scrollElement);
  var targetY = document.body.scrollHeight - elementY < window.innerHeight 
    ? document.body.scrollHeight - window.innerHeight 
    : elementY;
  var diff = targetY - startingY;
  var easing = function (t) { return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1; }
  var start;
  if (!diff) return;
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    var time = timestamp - start;
    var percent = Math.min(time / duration, 1);
    percent = easing(percent);
    scrollElement.scrollTop = startingY + diff * percent;
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
}

const productMedia = document.querySelector('.product-wrap .product-media');

if (document.querySelector('.choose-selector')) {
  if (window.innerWidth < 641) {
    document.querySelector('.choose-selector a').addEventListener('click', function() {
      doScrolling('#product-form-installment', 2000, productMedia);
    });
  }
}

// =================== Scroll Thumb Sync ===================
function updateThumbFromScroll() {
  const thumb = document.querySelector('#mediaThumbDragBox');
  const parentBox = document.getElementById('mediaThumbDragParent');
  if (!thumb || !parentBox) return;

  const boxHeightPct = (thumb.offsetHeight / parentBox.offsetHeight) * 100;
  const scrollMax = productMedia.scrollHeight - productMedia.clientHeight;
  const newTopPct = (productMedia.scrollTop / scrollMax) * (100 - boxHeightPct);
  thumb.style.top = newTopPct + '%';
  updateActiveFromThumb();
}
productMedia.addEventListener("scroll", updateThumbFromScroll);
addEventListener("DOMContentLoaded", updateThumbFromScroll);

// =================== Active Class From Visible Media ===================
function updateActiveFromThumb() {
  const mobItems = document.querySelectorAll('.media-grid > .media-grid-column');
  const thumbItems = document.querySelectorAll('.prod-thumb .media-grid-column');

  if (!productMedia) return;

  const viewportRect = productMedia.getBoundingClientRect();

  mobItems.forEach((item, index) => {
    const itemRect = item.getBoundingClientRect();

    // check overlap with productMedia viewport
    const overlap = !(viewportRect.bottom <= itemRect.top || viewportRect.top >= itemRect.bottom);

    if (overlap) {
      thumbItems[index]?.classList.add('active');
    } else {
      thumbItems[index]?.classList.remove('active');
    }
  });
}

// =================== Drag Scroll Logic ===================
var parentBox = document.getElementById('mediaThumbDragParent');
var box = document.getElementById('mediaThumbDragBox');
var isMouseDown = false;
var startY, startBoxTopPct;

if (box && parentBox) {
  box.addEventListener('mousedown', function(e) {
    isMouseDown = true;
    startY = e.clientY;
    startBoxTopPct = (box.offsetTop / parentBox.offsetHeight) * 100;
    e.preventDefault();
  });

  document.addEventListener('mouseup', function() {
    isMouseDown = false;
  });

  document.addEventListener('mousemove', function(e) {
    if (!isMouseDown) return;
    var deltaYPct = ((e.clientY - startY) / parentBox.offsetHeight) * 100;
    var boxHeightPct = (box.offsetHeight / parentBox.offsetHeight) * 100;
    var newTopPct = Math.max(0, Math.min(100 - boxHeightPct, startBoxTopPct + deltaYPct));
    box.style.top = newTopPct + '%';

    // Scroll content according to thumb
    var scrollMax = productMedia.scrollHeight - productMedia.clientHeight;
    productMedia.scrollTop = (scrollMax * newTopPct) / (100 - boxHeightPct);

    updateActiveFromThumb();
  });
}

// =================== Click-to-scroll (accurate positioning) ===================
if (document.querySelector('.prod-thumb-wrap')) {
  document.querySelector('.prod-thumb-wrap').addEventListener('dblclick', function(e) {
    const parentBoxRect = parentBox.getBoundingClientRect();
    const clickY = e.clientY - parentBoxRect.top;
    const boxHeightPct = (box.offsetHeight / parentBox.offsetHeight) * 100;
    let newTopPct = ((clickY - box.offsetHeight / 2) / parentBox.offsetHeight) * 100;
    newTopPct = Math.max(0, Math.min(100 - boxHeightPct, newTopPct));
    box.style.top = newTopPct + '%';
    const scrollMax = productMedia.scrollHeight - productMedia.clientHeight;
    productMedia.scrollTop = (scrollMax * newTopPct) / (100 - boxHeightPct);

    updateActiveFromThumb();
  });
}

// =================== CLICK on Thumb Image ===================
const thumbItems = document.querySelectorAll('.prod-thumb .media-grid-column');
const mobItems = document.querySelectorAll('.media-grid > .media-grid-column');

thumbItems.forEach((thumb, index) => {
  thumb.addEventListener('click', function() {
    if (mobItems[index]) {
      // Smooth scroll that media item into productMedia viewport
      productMedia.scrollTo({
        top: mobItems[index].offsetTop,
        behavior: "smooth"
      });

      // Update active classes (same as drag logic)
      updateActiveFromThumb();
    }
  });
});



// new code